<template>
  <div>
    <div class="navbar-free">
      <NavBarFreeMain />
    </div>
    <ModalSeasonSelect />
    <div class="season-and-team">
      <NavBarTournamentButtonMobile />
    </div>
    <div class="menu-sections">
      <MenuSectionsLanding />
    </div>
    <Lives :show="booleanIsLiveGamesModalOpen" @close="setBooleanIsLiveGamesModalOpen(false)" />
    <div class="content-section">
      <div>
        <RouterView />
      </div>
    </div>
    <Footer />
  </div>
</template>
<script>
import axios from 'axios';
import { mapMutations, mapState } from 'vuex';

export default {
  name: 'LandingMain',
  components: {
    NavBarFreeMain: () => import('@/components/Sections/Main/NavBarFreeMain'),
    ModalSeasonSelect: () => import('@/components/Elements/ModalSeasonSelect'),
    NavBarTournamentButtonMobile: () => import('@/components/Elements/NavBarTournamentButtonMobile'),
    MenuSectionsLanding: () => import('@/components/Elements/MenuSectionsLanding'),
    Footer: () => import('@/components/Sections/Main/Footer'),
    Lives: () => import('@/views/Lives'),
  },
  data() {
    return {
      objectMainContainer: null,
    };
  },
  computed: {
    ...mapState('leagueGeneral', ['booleanIsLiveGamesModalOpen']),
  },
  watch: {
    $route: {
      immediate: true,
      handler(to) {
        if (to.name !== 'extended-calendar') {
          if (!this.objectMainContainer) {
            this.objectMainContainer = document.getElementById('main-container');
          }
          this.objectMainContainer.scrollTop = 0;
        }
      },
    },
  },
  methods: {
    ...mapMutations('leagueGeneral', ['setBooleanAreLiveGames', 'setBooleanIsLiveGamesModalOpen']),
    async fillLiveGamesData(numberRetries = 3) {
      try {
        const response = await axios.get('https://qobetc4ze3.execute-api.us-east-2.amazonaws.com/prod/games/live');
        this.setBooleanAreLiveGames(!!(response.data && response.data.length));
      } catch (e) {
        if (numberRetries > 0) {
          await this.fillLiveGamesData(numberRetries - 1);
        } else {
          throw new Error(e);
        }
      }
    },
  },
  created() {
    window.localStorage.removeItem('widget-team');
    this.fillLiveGamesData();
  },
};
</script>
<style>
html > body {
  padding-top: 0 !important;
}
.is-fullheight-with-navbar-and-footer,
.is-fullheight-with-navbar-and-footer-mobile {
  height: calc(100% - 1px);
}
.select.is-info select:hover,
.select.is-info select.is-hovered {
  border-color: #bfc9d2 !important;
  font-family: 'Roboto-Medium' !important;
  font-size: 17px !important;
  font-weight: 500 !important;
}
.select.is-info select {
  border-color: #bfc9d2 !important;
  font-family: 'Roboto-Medium' !important;
  font-size: 17px !important;
  font-weight: 500 !important;
}
</style>
<style lang="scss" scoped>
.heightAux {
  @media screen and (max-width: 500px) {
    height: 500px !important;
  }
}
.color-active {
  color: black !important;
  background-color: #cbee6d !important;
  img {
    filter: brightness(0%) !important;
  }
}
.color-active:hover {
  cursor: pointer;
  opacity: 0.8;
}
.tools-mundial-cont {
  width: 100%;
  height: auto;
  position: relative;
  margin-top: 20px;
  &__row-one {
    width: 100%;
    height: 480px;
    display: inline-flex;
    @media screen and (max-width: 1328px) {
      display: inline-block;
      margin-bottom: 22px;
      height: auto;
    }
    &__group {
      width: 638px;
      display: inline-flex;
      height: auto;
      @media screen and (max-width: 1328px) {
        width: 100%;
        height: 480px;
      }
      @media screen and (max-width: 628px) {
        width: 100%;
        height: auto;
      }
      @media screen and (max-width: 428px) {
        display: inline-block;
      }
      &__datags-cont {
        width: 302.5px;
        height: auto;
        display: inline-block;
        border: 1px solid #c0c0c0;
        @media screen and (max-width: 1328px) {
          width: 49%;
          height: 480px;
        }
        @media screen and (max-width: 628px) {
          width: 49.8%;
          height: 412px;
        }
        @media screen and (max-width: 428px) {
          width: 100%;
          height: 151px;
        }
      }
      &__tops-cont {
        width: 303.5px;
        height: auto;
        // background: #e8e8e8;
        margin-left: 32px;
        display: inline-block;
        @media screen and (max-width: 1328px) {
          width: 49%;
          margin-left: 25px;
          height: 480px;
        }
        @media screen and (max-width: 628px) {
          margin-left: 2px;
          width: 49.8%;
          height: 410px;
        }
        @media screen and (max-width: 428px) {
          width: 100%;
          margin-left: 0%;
          margin-top: 25px;
        }
      }
    }
    &__calendar {
      width: 600px;
      margin-left: 32px;
      @media screen and (max-width: 1328px) {
        width: 100%;
        height: auto; //pasara a ser auto
        margin-left: 0;
        margin-top: 25px;
      }
      @media screen and (max-width: 828px) {
        width: 100%;
        margin-left: 0;
        margin-top: 25px;
      }
      @media screen and (max-width: 628px) {
        width: 100%;
        margin-left: 0;
        margin-top: 25px;
      }
    }
  }
  &__row-two {
    width: 100%;
    height: auto;
    display: inline-block;
    margin-top: 72px;
    @media screen and (max-width: 768px) {
      margin-top: 54px;
    }
    @media screen and (max-width: 500px) {
      margin-top: 12px;
    }
    &__table-general {
      width: 100%;
      display: inline-block;
      height: auto; //pasara a ser auto
    }
    &__bets-tool {
      width: 100%;
      display: inline-block;
      height: auto; //pasara a ser auto
      margin-top: 72px;
      @media screen and (max-width: 768px) {
        margin-top: 54px;
      }
      @media screen and (max-width: 500px) {
        margin-top: 12px;
      }
    }
  }
}
.landing-mundial {
  width: 100%;
  max-width: 1248px;
  display: inline-block;
  margin: 0 auto;
  height: auto;
  justify-content: center;
  margin-bottom: 0 !important;
}
.header-landing-mundial-movil {
  display: none;
  width: 100%;
  height: 168px;
  justify-content: center;
  align-content: center;
  align-items: center;
  @media screen and (max-width: 500px) {
    display: inline-block;
  }
  &__data {
    width: 100%;
    height: 72px;
    display: inline-flex;
    justify-content: center;
    align-content: center;
    margin-top: 10px;
    &__tournament-cont {
      width: 65%;
      height: 41px;
      display: inline-block;
      justify-content: left;
      align-content: center;
      align-items: center;

      &__label {
        font-family: 'Roboto-Regular';
        font-size: 15px;
        height: 24px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 24px;
        letter-spacing: -0.13px;
        text-align: left;
        color: #3c444b;
        margin-right: 10px;
        width: 20%;
        margin-left: 10px;
      }
      &__select {
        width: 95%;
        height: 41px;
        margin-left: 10px;
        @media screen and (max-width: 400px) {
          width: 89%;
        }
      }
    }

    &__live-bottom-cont {
      width: 35%;
      height: 41px;
      display: inline-flex;
      justify-content: right;
      align-content: center;
      align-items: center;
      &__buttom {
        width: 115px;
        height: 40px;
        display: inline-flex;
        justify-content: center;
        align-items: center;
        align-content: center;
        border-radius: 8px;
        background-color: #e8e8e8;
        font-family: 'Avenir-Pro-Bold';
        font-size: 16px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        letter-spacing: normal;
        text-align: left;
        color: #c9ccce;
        margin-right: 10px;
        padding-left: 10px;
        margin-top: 47px;

        img {
          margin-left: 3px;
          filter: grayscale(1);
        }
      }
    }
  }
  &__logo-sponsor-cont {
    width: 100%;
    height: 85.7px;
    display: inline-flex;
    justify-content: center;
    align-content: center;
    margin-left: 0%;
    align-items: center;
    position: relative;
    &__sep {
      width: 100%;
      height: 2px;
      border-bottom: 1px dotted #aeb0b2;
      position: absolute;
    }
    &__imgcont {
      width: 212px;
      height: 85.7px;
      background: white;
      position: absolute;
      display: inline-flex;
      justify-content: center;
      align-content: center;
      align-items: center;
      img {
        width: 68%;
      }
    }
  }
}
.header-landing-mundial {
  width: 100%;
  display: inline-flex;
  height: 110px;
  display: inline-flex;
  justify-content: center;
  align-content: center;
  align-items: center;
  @media screen and (max-width: 500px) {
    display: none;
  }
  &__tournament-cont {
    width: 27.36%;
    height: 41px;
    display: inline-flex;
    justify-content: left;
    align-content: center;
    align-items: center;
    @media screen and (max-width: 1120px) {
      width: 30%;
    }
    @media screen and (max-width: 960px) {
      width: 31%;
    }
    @media screen and (max-width: 860px) {
      width: 44.5%;
    }
    @media screen and (max-width: 600px) {
      width: 45%;
    }

    &__label {
      font-family: 'Roboto-Regular';
      font-size: 18px;
      height: 41px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 35px;
      letter-spacing: -0.13px;
      text-align: left;
      color: #3c444b;
      margin-right: 10px;
      width: 20%;
      margin-left: 10px;
      @media screen and (max-width: 560px) {
        margin-left: 3px;
        margin-right: 5px;
        width: 25%;
      }
    }
    &__select {
      width: 80%;
      height: 41px;
    }
  }
  &__sep-cont {
    width: 6.24%;
    height: 41px;
    display: inline-flex;
    justify-content: center;
    align-content: center;
    align-items: center;
    &__line {
      width: 2px;
      height: 16px;
      border-right: 1px solid #aeb0b2;
    }
    @media screen and (max-width: 860px) {
      width: 7.24%;
    }
    @media screen and (max-width: 650px) {
      width: 5.24%;
    }
  }
  &__sep-cont-movil {
    width: 6.24%;
    height: 41px;
    display: none;
    justify-content: center;
    align-content: center;
    align-items: center;
    &__line {
      width: 2px;
      height: 16px;
      border-right: 1px solid #aeb0b2;
    }
    @media screen and (max-width: 860px) {
      display: inline-flex;
      width: 7.24%;
    }
    @media screen and (max-width: 650px) {
      width: 6.24%;
    }
  }
  &__live-bottom-cont {
    width: 9.21%;
    height: 41px;
    display: inline-flex;
    justify-content: center;
    align-content: center;
    align-items: center;
    @media screen and (max-width: 1120px) {
      width: 11.21%;
    }
    @media screen and (max-width: 960px) {
      width: 13.21%;
    }
    @media screen and (max-width: 860px) {
      width: 16.21%;
    }
    @media screen and (max-width: 600px) {
      width: 18.21%;
    }

    &__buttom {
      width: 115px;
      height: 40px;
      display: inline-flex;
      justify-content: center;
      align-items: center;
      align-content: center;
      border-radius: 8px;
      background-color: #e8e8e8;
      font-family: 'Avenir-Pro-Bold';
      font-size: 16px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      letter-spacing: normal;
      text-align: left;
      color: #c9ccce;

      padding-left: 10px;
      img {
        margin-left: 3px;
        filter: grayscale(1);
      }
    }
  }
  &__logo-sponsor-cont {
    width: 55.85%;
    height: 85.7px;
    display: inline-flex;
    justify-content: center;
    align-content: center;
    margin-left: 2.4%;
    align-items: center;
    position: relative;
    @media screen and (max-width: 1120px) {
      width: 50%;
    }
    @media screen and (max-width: 960px) {
      width: 47%;
    }
    @media screen and (max-width: 860px) {
      margin-left: 0%;
      width: 212px;
      justify-content: right;
    }
    @media screen and (max-width: 650px) {
      width: 180px;
    }
    @media screen and (max-width: 600px) {
      width: 150px;
    }
    &__sep {
      width: 100%;
      height: 2px;
      border-bottom: 1px dotted #aeb0b2;
      position: absolute;
      @media screen and (max-width: 860px) {
        display: none;
      }
    }
    &__imgcont {
      width: 212px;
      height: 85.7px;
      background: white;
      position: absolute;
      display: inline-flex;
      justify-content: center;
      align-content: center;
      align-items: center;
      @media screen and (max-width: 650px) {
        width: 180px;
      }
      @media screen and (max-width: 600px) {
        width: 150px;
      }
      img {
        width: 78%;
        @media screen and (max-width: 860px) {
          width: 53%;
        }
        @media screen and (max-width: 600px) {
          width: 65%;
        }
      }
    }
  }
}

.season-and-team {
  width: 100%;
  margin: 10px 0;
  display: none;

  @media screen and (max-width: 566px) {
    display: block;
  }
}

.menu-sections {
  position: -webkit-sticky;
  position: sticky;
  padding-top: 6px;
  top: 60px;
  width: 100%;
  background-color: white;
  z-index: 5;
}

.content-section {
  order: 4;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 100%;

  & > div {
    height: 100%;
  }
}

.navbar-free {
  width: 100%;
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 6;
}

@media screen and (max-width: 767px) {
  .content-section {
    background-color: #ffffff !important;
  }
}
</style>
